import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiVisa, BaseApiTemplateService} from '../../shared';
import {Core2Config} from '../../shared';
import { MyClaimDocumentHdrAttachmentFlowContainerModel} from '../../../../../../models';
import {Observable} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class MyClaimDocumentHdrAttachmentFlowService extends BaseApiTemplateService<MyClaimDocumentHdrAttachmentFlowContainerModel> {

  endpointSubPath = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'document-hdr-attachment-flows/' ;
  readonly url = Core2Config.DOMAIN_URL + this.endpointSubPath + 'backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + this.endpointSubPath + 'backoffice-ep';
    this.endpoint_path = this.endpointSubPath + 'backoffice-ep';
    this.httpClient = http;
  }

  uploadImage(formData: FormData, docHdrGuid, visa: ApiVisa) {
    let url = Core2Config.DOMAIN_URL + this.endpointSubPath + 'add-files/' + 'backoffice-ep/' + docHdrGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpointSubPath + 'add-files/' + 'backoffice-ep/' + docHdrGuid;
    }
    return this.httpClient.post(url, formData, this.getHttpHeader(visa));
  }

  updateImage(formData: FormData, attachmentFlowGuid, visa: ApiVisa) {
    let url = Core2Config.DOMAIN_URL + this.endpointSubPath + 'replace-files/backoffice-ep/' + attachmentFlowGuid;
    console.log(this.apiUrl + 'photo', formData);
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpointSubPath + 'replace-files/backoffice-ep/' + attachmentFlowGuid;
    }
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }

  getImage(hdrGuid: string, visa: ApiVisa): Observable<Blob> {
    let url = Core2Config.DOMAIN_URL + this.endpointSubPath + 'files/backoffice-ep/' + hdrGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpointSubPath + 'files/backoffice-ep/' + hdrGuid;
    }
    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
  }



}


